import React from 'react';
import DaumPostcode from 'react-daum-postcode';
import '../css_admin/Post.css';
import axios from 'axios';

import {
    Modal,
    Box,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import key from '../config/key';

const MobilePost = ({ address, setaddress, onClose }) => {
    const complete = data => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
        if (data.bname) extraAddress += data.bname;
        if (data.buildingName) extraAddress += (extraAddress ? `, ${data.buildingName}` : data.buildingName);
            fullAddress += extraAddress ? ` (${extraAddress})` : '';
        }

        const kakaoAK = 'KakaoAK ' + key.KAKAO_APP_KEY;
        axios
        .get(`https://dapi.kakao.com/v2/local/search/address.json?query=${fullAddress}`, {
            headers: { Authorization: kakaoAK }
        })
        .then(res => {
            const loc = res.data.documents[0].address;
            setaddress({
                ...address,
                address: fullAddress,
                postal: data.zonecode,
                latitude: loc.y,
                longitude: loc.x,
            });
            onClose();
        });
    };

    return (
        <Modal open onClose={onClose} disableScrollLock>
        {/* 화면 전체를 덮는 Flex 컨테이너 */}
        <Box
            sx={{
                width: { xs: 'calc(100vw - 2px)', sm: 600 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                p: 2,
                boxSizing: 'border-box',
            }}
        >
            {/* 실제 팝업 박스 */}
            <Box
                sx={{
                    width: '90vw',        // 모바일: 화면 90%
                    maxWidth: 600,           // 최대 600px
                    maxHeight: '90vh',        // 최대 화면 높이 90%
                    overflowY: 'auto',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 14,
                    p: 3,
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h6">주소 검색</Typography>
                    <CloseIcon onClick={onClose} sx={{ cursor: 'pointer' }} />
                </Box>

                <Box sx={{ mt: 2 }}>
                    <DaumPostcode autoClose onComplete={complete} />
                </Box>
            </Box>
        </Box>
        </Modal>
    );
};

export default MobilePost;
